var exports = {
  "KE": "SelectionFormattingToolbar.module__toolbar___SWhoS3",
  "x6": "SelectionFormattingToolbar.module__button___SWhoS3",
  "rK": "SelectionFormattingToolbar.module__buttonActive___SWhoS3",
  "Kk": "SelectionFormattingToolbar.module__icon___SWhoS3",
};

module.exports = exports;
